const markets = [

    {
        id: "BE",
        market: "BE",
        decimalSeparator: ",",
        thousandsSeparator: ".",
        decimalPlaces: 2,
        currencySymbol: "€",
        percentageSymbol: "%",
        currencyCode: "EUR",
        currencyDescription: "Euro"
    },
    {
        id: "NL",
        market: "NL",
        decimalSeparator: ",",
        thousandsSeparator: ".",
        decimalPlaces: 2,
        currencySymbol: "€",
        percentageSymbol: "%",
        currencyCode: "EUR",
        currencyDescription: "Euro"
    }

];

export const marketConfig = (id) => {
    return markets.find((m)=>{
        return m.id === id;
    });
};

export default markets;

